import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const reopenSectionsMutation = gql`
  mutation reopenSections(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $sections: [Section!]!
    $userId: String!
  ) {
    reopenSections(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      sections: $sections
      userId: $userId
    )
  }
`

export type Section = {
  name: SectionName
  comment: string
}

export enum SectionName {
  identity = 'identity',
  credit = 'credit',
  income = 'income',
  residential = 'residential',
  organisation = 'organisation',
  financial = 'financial',
}

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  sections: Section[]
  userId: string
}

export type ReopenSectionsData = {
  removeIncome: string | unknown
}

export const useReopenSectionsMutation: WrappedMutation<
  ReopenSectionsData,
  MutationVars
> = () =>
  useMutation<ReopenSectionsData, MutationVars>(reopenSectionsMutation, {
    client: agentClient,
  })
